"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FuturesBalancesTableHeader = require("./FuturesBalancesTableHeader");
Object.keys(_FuturesBalancesTableHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FuturesBalancesTableHeader[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _FuturesBalancesTableHeader[key];
    }
  });
});